import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { IItemsListSort } from '../fi-items-list.d';

export interface IItemsListSortOption {
    columnName: string;
    textId: string;
    defaultSortDirection: boolean;
    isHidden?: () => boolean;
    sortDirectionOptions: { value: boolean; textId: string }[];
}

@Component({
    selector: 'fi-items-list-sort-select',
    templateUrl: './fi-items-list-sort-select.component.html',
    styleUrls: ['./fi-items-list-sort-select.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-items-list-sort-select' },
    standalone: false,
})
export class FiItemsListSortSelectComponent {
    @Input({ required: true }) options: IItemsListSortOption[] = [];
    @Input({ required: true }) sortColumn: string;
    @Input({ required: true }) sortDirection: boolean;
    @Output() selectedSortChange = new EventEmitter<IItemsListSort>();

    protected get selectedSortOption(): IItemsListSortOption {
        return this.options.find((option) => option.columnName === this.sortColumn);
    }

    protected setSelectedOption($event: MouseEvent, option: IItemsListSortOption): void {
        $event.stopPropagation();
        this.sortColumn = option.columnName;
        this.sortDirection = option.defaultSortDirection;
        this.emitSortChange();
    }

    protected setSortDirection($event: MouseEvent, sortDirection: boolean): void {
        $event.stopPropagation();
        this.sortDirection = sortDirection;
        this.emitSortChange();
    }

    protected isSortDirectionSelected(sortDirectionValue: boolean): boolean {
        return this.sortDirection === sortDirectionValue;
    }

    protected isSortOptionSelected(sortOption: IItemsListSortOption): boolean {
        return this.sortColumn === sortOption.columnName;
    }

    protected emitSortChange(): void {
        this.selectedSortChange.emit({
            ColumnName: this.sortColumn,
            SortDirection: this.sortDirection,
        });
    }
}
